class CollectionListInfiniteSlider extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;
    if (!this.slider || !this.nextButton) return;

    this.loopSetWidth = 0;
    this.isAdjustingScroll = false;
    this.scrollPositionInitialized = false;

    this.measureLoopSet = this.measureLoopSet.bind(this);
    this.onInfiniteScroll = this.onInfiniteScroll.bind(this);

    this.loopResizeObserver = new ResizeObserver(this.measureLoopSet);
    this.loopResizeObserver.observe(this.slider);
    this.measureLoopSet();

    this.slider.addEventListener('scroll', this.onInfiniteScroll, { passive: true });
  }

   update() {
    super.update();
    this.prevButton.removeAttribute('disabled');
    this.nextButton.removeAttribute('disabled');
  }

  setScrollInstant(position) {
    this.isAdjustingScroll = true;
    this.slider.style.setProperty('scroll-behavior', 'auto');
    this.slider.scrollLeft = position;
    this.slider.style.removeProperty('scroll-behavior');
    this.isAdjustingScroll = false;
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: 'smooth',
    });
  }

  measureLoopSet() {
    const slides = this.slider.querySelectorAll('[id^="Slide-"]:not([data-clone])');
    if (slides.length < 1) {
      this.loopSetWidth = 0;
      return;
    }

    const first = slides[0];
    const last = slides[slides.length - 1];
    const nextWidth = last.offsetLeft + last.offsetWidth - first.offsetLeft;

    if (nextWidth <= 0) return;

    const previousWidth = this.loopSetWidth;
    this.loopSetWidth = nextWidth;

    if (!this.scrollPositionInitialized) {
      this.initializeScrollPosition();
      return;
    }

    if (previousWidth > 0 && previousWidth !== nextWidth) {
      const ratio = this.slider.scrollLeft / previousWidth;
      this.setScrollInstant(ratio * nextWidth);
    }
  }

  initializeScrollPosition() {
    if (!this.loopSetWidth || this.scrollPositionInitialized) return;

    this.setScrollInstant(this.loopSetWidth);
    this.scrollPositionInitialized = true;
  }

  onInfiniteScroll() {
    if (this.isAdjustingScroll || !this.loopSetWidth) return;

    const { scrollLeft } = this.slider;
    const setWidth = this.loopSetWidth;
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;

    if (scrollLeft >= setWidth * 2 - 2 || scrollLeft >= maxScroll - 2) {
      this.setScrollInstant(scrollLeft - setWidth);
      return;
    }

    if (scrollLeft <= 2) {
      this.setScrollInstant(scrollLeft + setWidth);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!this.sliderItemOffset) this.initPages();

    const step = Number(event.currentTarget.dataset.step || 1);
    const delta = step * this.sliderItemOffset;
    const target =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + delta
        : this.slider.scrollLeft - delta;

    this.setSlidePosition(target);
  }
}

customElements.define('collection-list-infinite-slider', CollectionListInfiniteSlider);
